import { Avatar, Stack, ThemeIcon, Tooltip } from "@mantine/core";
import ModelEmailSelector from "../../../../../../components/Selectors/ModelEmailSelector";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import {
  IconMail,
  IconMailFilled,
  IconSignature,
  IconTemplate,
} from "@tabler/icons-react";
import EmailSignatureSelector from "../../../../../../components/Selectors/EmailSignatureSelector";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import EmailAccountSelectorWorkflow from "../components/EmailAccountSelectorWorkflow";
import { IconEmail } from "../../../../../../assets/icons/IconEmail";
import account_placeholder from "../../../../../../assets/icons/account_placeholder.png";
// import { useReactFlow } from "reactflow";

const EmailNodeBody = ({ node_id, data, xPos, yPos }) => {
  const lang = useLanguage((s) => s.language);
  const updateNodeData = useFlowStore((s) => s.updateNodeData);

  const handleModelChange = (v) => {
    const newValue = v?.id ? parseInt(v?.id) : null;
    updateNodeData(node_id, {
      model_id: newValue,
    });
  };
  const handleSenderChange = (v) => {
    let isPool = v?.number_of_accounts !== undefined;
    const newValue = v?.id ? parseInt(v?.id) : null;
    updateNodeData(node_id, {
      [isPool ? "pool_id" : "integration_id"]: newValue,
      [isPool ? "integration_id" : "pool_id"]: null,
      signature_id: v?.email_signatures_id || data?.signature_id || null,
    });
  };
  const handleSignatureChange = (v) => {
    const newValue = v?.id ? parseInt(v?.id) : null;
    updateNodeData(node_id, {
      signature_id: newValue,
    });
  };

  // const setSelectedNode = useFlowStore((s) => s.setSelectedNode);
  // const reactflow = useReactFlow();
  // const handleNoValueClick = (e, toCheck) => {
  //   e?.stopPropagation();
  //   if (!toCheck) {
  //     setSelectedNode({ data, id: node_id, toAdvanced: false });
  //     setTimeout(() => {
  //       reactflow?.setCenter(xPos + 142, yPos + 132, {
  //         duration: 500,
  //         zoom: 1,
  //       });
  //     }, 201);
  //   }
  // };

  return (
    <Stack w={"100%"} pb={6} gap={"xs"} bg={"#fff"} style>
      <EmailAccountSelectorWorkflow
        value={data?.pool_id || data?.integration_id}
        className="nodrag nopan"
        onChange={handleSenderChange}
        // onClick={(e) =>
        //   handleNoValueClick(e, data?.pool_id || data?.integration_id)
        // }
        leftSection={
          <Tooltip label={lang.campaign.selectors.senders.tooltip_linkedin}>
            <Avatar src={account_placeholder} size={20} />
          </Tooltip>
        }
        leftSectionWidth={36}
        required
        size={"sm"}
        radius="lg"
        placeholder={lang.campaign.selectors.senders.placeholder}
        isPool={!!data?.pool_id}
        variant="contained"
        styles={{
          input: {
            background: "#f2eaff96",
          },
        }}
      />
      <ModelEmailSelector
        value={data?.model_id}
        className="nodrag nopan"
        onChange={handleModelChange}
        // onClick={(e) => handleNoValueClick(e, data?.model_id)}
        required
        size={"sm"}
        radius="lg"
        placeholder={lang.campaign.selectors.email.tooltip}
        leftSection={
          <Tooltip label={lang.campaign.selectors.email.placeholder}>
            <ThemeIcon>
              <IconMailFilled size={16} />
            </ThemeIcon>
          </Tooltip>
        }
        leftSectionWidth={36}
        variant="contained"
        styles={{
          input: {
            background: "#f2eaff96",
          },
        }}
      />
      <EmailSignatureSelector
        className="nodrag nopan"
        placeholder={lang.campaign.selectors.signature.tooltip}
        value={data?.signature_id}
        accountIsPool={!!data?.pool_id}
        onChange={handleSignatureChange}
        required
        size={"sm"}
        leftSection={
          <Tooltip label={lang.campaign.selectors.signature.placeholder}>
            <ThemeIcon>
              <IconSignature size={16} />
            </ThemeIcon>
          </Tooltip>
        }
        selectorProps={{
          variant: "contained",
          leftSectionWidth: 36,
          radius: "lg",
          styles: {
            input: {
              background: "#f2eaff96",
            },
          },
        }}
      />
    </Stack>
  );
};

export default EmailNodeBody;
